import {isFunction} from 'lodash';
import store from '@/libs/core/store/store';
import {StoreName} from '@/libs/core/store/store-name';
import {CrudAction, CrudResponseAction} from '@/libs/core/crud/crud-action';
import {CrudGetter} from '@/libs/core/crud/crud-getter';

export function createStoreDispatcher(storeName: StoreName) {
    return (action: CrudAction | CrudResponseAction, payload: any) => store.dispatch(`${storeName}/${action}`, payload || {})
}

export function createStoreGetter(storeName: StoreName) {
    return (getter: CrudGetter, ...params: any[]) => {
        const val = store.getters[`${storeName}/${getter}`];
        return isFunction(val) ? val(...params) : val;
    }
}
